import { Button, Grid, GridColumn, Icon, Input, SelectOption, useIntl } from "@metsooutotec/modes-react-components"
import React, { ReactNode, useState } from "react"
import StockAllocationDeleteModal from "../../stock-allocation/stock-allocation-delete-modal"
import DispatchModal from "../dispatch-modal"
import { observer } from "mobx-react-lite"
import styles from "./dispatched-sensors-section.module.css"
import { SDASensor } from "features/iot/stock-management/models/sensor-dispatch-allocation"
import { DeleteStockAllocation } from "features/iot/stock-management/models/stock-management-models"
import { itemViewDetailsContainerStyles, itemViewListExtraTopPaddingStyles, itemViewSubtitleStyles } from "components/common-style/common-style"

interface CustomSensorInputProps {
    listOfSensors: SDASensor[]
    partNumber: string
    pickedCustomer: SelectOption | undefined
    pickedSite: SelectOption | undefined
    dispatchDate: Date
}

const DispatchedSensorsSection: React.FC<CustomSensorInputProps> = observer(
    ({ listOfSensors, partNumber, pickedCustomer, pickedSite, dispatchDate }) => {
        const { formatMessage } = useIntl()
        const [sensorToEdit, setSensorToEdit] = useState<SDASensor | undefined>()
        const [isDispatchModalOpen, setIsDispatchModalOpen] = useState<boolean>(false)
        const [stockAllocationToDelete, setStockAllocationToDelete] = useState<DeleteStockAllocation | undefined>(undefined)

        const [isDeleteAllocationOpen, setIsDeleteAllocationOpen] = useState<boolean>(false)
        const dipatchActionsHandlers = {
            open: () => {
                setIsDispatchModalOpen(true)
            },
        }

        const sensorsActionsHandlers = {
            close: () => {
                setStockAllocationToDelete(undefined)
                setIsDeleteAllocationOpen(false)
                setSensorToEdit(undefined)
                setIsDispatchModalOpen(false)
            },
            edit: (sensor: SDASensor) => {
                setSensorToEdit(sensor)
                setIsDispatchModalOpen(true)
            },
            delete: (senssor: SDASensor) => {
                const toDelete: DeleteStockAllocation = {
                    listOfSensorsMacAddress: [senssor.macAddress],
                    partNumber: partNumber,
                }
                setStockAllocationToDelete(toDelete)
                setIsDeleteAllocationOpen(true)
            },
        }

        const sensorCell = (sensor: SDASensor): ReactNode => {
            const icons = (
                <span className={styles.sensorCell}>
                    <Icon key={`icon-edit-16-${sensor.macAddress}`} className='icon-edit-16' onClick={() => sensorsActionsHandlers.edit(sensor)} />
                    <Icon
                        key={`icon-trash-16-${sensor.macAddress}`}
                        className='icon-trash-16'
                        onClick={() => sensorsActionsHandlers.delete(sensor)}
                    />
                </span>
            )

            return (
                <GridColumn key={`column-${sensor.macAddress}`}>
                    <Input key={sensor.macAddress} value={sensor.serialNumber} icon={icons} readOnly />
                </GridColumn>
            )
        }

        const rightDispatchButtons: ReactNode = (
            <>
                <Button key={"rightDispatchButtons"} icon='icon-plus-16' labelPosition='right' onClick={dipatchActionsHandlers.open} primary>
                    {formatMessage("dispatch.addNew")}
                </Button>
            </>
        )
        return (
            <>
                <div style={itemViewDetailsContainerStyles}>
                    <div className={styles.rightDispatchButtons}>
                        <h3 style={itemViewSubtitleStyles}>{formatMessage("dispatch.serialNumbers")}:</h3>
                        {rightDispatchButtons}
                    </div>
                    <div style={itemViewListExtraTopPaddingStyles}>
                        <Grid columns={4} key={"dispatched-sensors-section-columns"}>
                            {listOfSensors.length > 0 ? (
                                listOfSensors.map(s => {
                                    return sensorCell(s)
                                })
                            ) : (
                                <></>
                            )}
                        </Grid>
                    </div>
                </div>
                {isDeleteAllocationOpen && (
                    <StockAllocationDeleteModal
                        isOpen={isDeleteAllocationOpen}
                        setIsOpen={setIsDeleteAllocationOpen}
                        macAddresses={stockAllocationToDelete?.listOfSensorsMacAddress ?? []}
                        partNumber={stockAllocationToDelete?.partNumber ?? ""}
                    />
                )}
                {isDispatchModalOpen && partNumber && pickedCustomer?.value && pickedSite?.text && (
                    <DispatchModal
                        isOpen={isDispatchModalOpen}
                        onClose={sensorsActionsHandlers.close}
                        partNumber={partNumber}
                        sensorToEdit={sensorToEdit as SDASensor}
                        dispatchDate={dispatchDate}
                        customerId={pickedCustomer?.value}
                        siteId={pickedSite?.value}
                        siteName={pickedSite.text}
                    />
                )}
            </>
        )
    },
)

export default DispatchedSensorsSection
